export const ModifiedFields = {
  SPACING: ['Spacing'],
  QUANTITY: ['Quantity'],
  CLEAN_UP: ['CleanUp'],
  COLOR: ['Color'],
  PRODUCT: ['Product'],
  DELIVERY_DATE: ['DeliveryDate'],
  DELIVERY_TIME: ['DeliveryTime'],
  CONTACT: ['Contact'],
  INSTRUCTIONS: ['Instructions'],
  PURCHASE_ORDER: ['PurchaseOrder'],
  APPLICATION: ['Application'],
  LOAD_SIZE: ['LoadSize'],
  SLUMP: ['Slump'],
  CONTRACT: ['Contract'],
  POD: ['PointOfDelivery'],
  PLANT: [
    'Plant',
    'ToJobTravelTime',
    'ToPlantTravelTime',
    'Distance',
  ],
  // CXGOOLS-7585: transit values on their own (without a plant change). Used when the
  // plant -> POD calculated route is applied (e.g. the user changed the Point of Delivery),
  // so the partial payload tells the backend a new schedule is coming.
  TRANSIT: ['ToJobTravelTime', 'ToPlantTravelTime', 'Distance'],
  VALUE_ADDED: ['ValueAdded'],
  UNLOAD_TYPE: ['UnloadType'],
  HOLD_QUANTITY: ['holdQuantity'],
};
